type ErrorData = {
  message?: string;
  errors?: Record<string, unknown>;
};

export class APIError extends Error {
  status: number;
  errors?: Record<string, unknown>;

  constructor(
    message: string,
    status: number,
    errors?: Record<string, unknown>,
  ) {
    super(message);
    this.name = 'APIError';
    this.status = status;
    this.errors = errors;
  }
}

export const throwError = (
  status: number,
  statusText: string,
  errorData?: unknown,
) => {
  let errorMessage = statusText || 'An error occurred';
  let errors: Record<string, unknown> | undefined = undefined;

  if (status === 422 && errorData && isErrorData(errorData)) {
    errors = errorData.errors;
    errorMessage =
      typeof errors?.error === 'string' ? errors.error : 'Validation Failed';
  } else {
    const data = errorData as { message?: string };
    errorMessage = data?.message || errorMessage;
  }

  throw new APIError(errorMessage, status, errors);
};

const isErrorData = (data: unknown): data is ErrorData => {
  return typeof data === 'object' && data !== null && 'errors' in data;
};
